import { FeatureCollection, GeoJsonProperties, Geometry } from "geojson";
import { ListParams } from "../models/listParams";
import { BaseWebService } from "./base.web.service";
import { OgcParams } from "../models/geo/ogcParams";
import { PagedResult } from "../models/pagedResult";
import { LayerAsset } from "../models/maps/layerAsset";

export class AssetsWebService extends BaseWebService {

    // Asset layers

    public async getAssetsLayers(organizationId: string, listParams: ListParams): Promise<PagedResult<LayerAsset>> {
        const params = this.createListParams(listParams);
        const headers = await this.getHeadersJson(true, organizationId);

        const url = `${this.appConfig.serviceAssetsUrl}/api/v1/asset-layers${params}`;
        return this.makeRequest(url, 'GET', headers);
    }

    // OGC features

    public async getAssetsOGCFeatures(organizationId: string, listParams: ListParams) {
        const params = this.createListParams(listParams);
        const headers = await this.getHeadersJson(true, organizationId);
        const url = `${this.appConfig.serviceAssetsUrl}/api/v1/ogc-features${params}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getAssetsOGCFeaturesCollections(organizationId: string, listParams: ListParams) {
        const params = this.createListParams(listParams);
        const headers = await this.getHeadersJson(true, organizationId);
        const url = `${this.appConfig.serviceAssetsUrl}/api/v1/ogc-features/collections${params}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getAssetsOGCFeaturesCollectionById(assetLayerId: string, organizationId: string) {
        const headers = await this.getHeadersJson(true, organizationId);
        const url = `${this.appConfig.serviceAssetsUrl}/api/v1/ogc-features/collections/${assetLayerId}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getAssetsOGCFeaturesCollectionsQueryables(assetLayerId: string, organizationId: string) {
        const headers = await this.getHeadersJson(true, organizationId);
        const url = `${this.appConfig.serviceAssetsUrl}/api/v1/ogc-features/collections/${assetLayerId}/queryables`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getAssetsOgcFeaturesCollectionsSchema(assetLayerId: string, organizationId: string) {
        const headers = await this.getHeadersJson(true, organizationId);
        const url = `${this.appConfig.serviceAssetsUrl}/api/v1/ogc-features/collections/${assetLayerId}/schema`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getAssetsOgcFeaturesCollectionsItems(assetLayerId: string, organizationId: string, ogcParams: OgcParams): Promise<FeatureCollection<Geometry, GeoJsonProperties>> {
        const params = this.createOgcParams(ogcParams);
        const headers = await this.getHeadersJson(true, organizationId);
        const url = `${this.appConfig.serviceAssetsUrl}/api/v1/ogc-features/collections/${assetLayerId}/items${params}`;
        return this.makeRequest<FeatureCollection<Geometry, GeoJsonProperties>>(url, 'GET', headers);
    }
}
